import Request from './request'
import i18n from '@/i18n';
import snackbar from '@/plugins/snackbar';
import store from '../store'

async function fetch (data) {
  return Request('get', 'api/foods/', data)
}

async function fetchOne (id) {
  // 获取单个
  return Request('get', 'api/foods/' + id)
}

async function fetchCostCardInfo (id) {
  return Request('get', 'api/formula-cost-card/get-cost-card?formula_id=' + id)
}

async function save (id, data) {
  // 编辑或新建数据（有id为编辑，没有id为新建）
  if (id) {
    return Request('post', 'api/foods/edit?id=' + id, data)
  } else {
    return Request('post', 'api/foods/add', data)
  }
}

async function del (id) {
  // 删除数据
  return Request('delete', 'api/foods/delete/' + id)
}

async function imports(file) {// 导入
  var data = new FormData();
  data.append("excel", file);
  return Request('post', "api/foods/import", data);
}

async function foodsExport(data) {// 菜品导出
  store.dispatch("fullscreenLoading");
  const response = await Request('get', "api/foods/export", data);
  if (response.data && response.data.status.isOK()) {
      snackbar.info(i18n.t("Export.recordedHint"));
  }
  store.dispatch("fullscreenLoadingStop");
  return response;
}

async function getLogs (data) {
  // 获取日志
  return Request('get', 'api/foods/food-logs/', data)
}

export default {
  fetch,
  fetchOne,
  fetchCostCardInfo,
  save,
  del,
  imports,
  foodsExport,
  getLogs,
}
